// extracted by mini-css-extract-plugin
module.exports = {"categoriesBanner":"LensHomePage_categoriesBanner__qeBwD","mobileCategoriesBanner":"LensHomePage_mobileCategoriesBanner__bmkfR"};